"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var ProductProperty = /*#__PURE__*/function (_Vue) {
  function ProductProperty() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductProperty);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductProperty, [].concat(args));
    (0, _defineProperty2.default)(_this, "properties", void 0);
    (0, _defineProperty2.default)(_this, "data", [{
      name: "",
      details: [{
        value: ""
      }]
    }, {
      name: "",
      details: [{
        value: ""
      }]
    }]);
    return _this;
  }
  (0, _inherits2.default)(ProductProperty, _Vue);
  return (0, _createClass2.default)(ProductProperty, [{
    key: "addProperty",
    value: function addProperty() {
      this.data.push({
        name: "",
        details: [{
          value: ""
        }]
      });
    }
  }, {
    key: "transformData",
    value: function transformData(_ref) {
      var _this2 = this;
      var attribute1 = _ref.attribute1,
        attribute2 = _ref.attribute2,
        productAttributes = _ref.productAttributes;
      this.data[0].name = attribute1;
      this.data[1].name = attribute2;
      this.data[1].details = [];
      this.data[0].details = [];
      productAttributes.forEach(function (element) {
        _this2.data[element.attribute - 1].details.push({
          value: element.value
        });
      });
    }
  }, {
    key: "transformDataToSubmit",
    value: function transformDataToSubmit() {
      var attribute1 = this.data[0].name;
      var attribute2 = this.data[1].name;
      var attributes = [];
      this.data.forEach(function (element, index) {
        element.details.forEach(function (e) {
          attributes.push({
            value: e.value,
            attribute: index + 1
          });
        });
      });
      return {
        attribute1: attribute1,
        attribute2: attribute2,
        attributes: attributes
      };
    }
  }, {
    key: "addDetail",
    value: function addDetail(item) {
      item.details.push({
        value: ""
      });
    }
  }, {
    key: "handleDeleteProp",
    value: function handleDeleteProp(index) {
      this.data.splice(index, 1);
    }
  }, {
    key: "handleDeleteDetail",
    value: function handleDeleteDetail(index, details) {
      details.splice(index, 1);
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductProperty.prototype, "properties", void 0);
ProductProperty = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ProductProperty);
var _default = exports.default = ProductProperty;